export default __webpack_public_path__ + "static/media/socialconnection.af2d7a4e.gif";